import React from 'react'
import { BUTTON, FRONTPAGE_DESKTOP_ELEMENT, FRONTPAGE_SANDWICH_ELEMENT, GRID_ELEMENT, LIST_ELEMENT, OVERVIEW_ELEMENT, SHOWTIMES_ELEMENT } from '../constants/mobileFrontElements'
import Overview from '../Overview'
import SelectionsDisplayList from '../SelectionsDisplayList'
import { MAIN } from '../../../client/js/constants/programSectionTypes'
import ReactScrollLink from '../General/ReactScollLink'
import getMomentDateObj from '../functions/getMomentDateObj'
import getMomentNow from '../functions/getMomentNow'

const PageFrontCustomMobile = ({
    location, 
    ads, 
    advertisements,
    movies, 
    highlights,
    siteHeaderData, 
    programOverviewStartviewType,  
    itemSelectionsDisplay, 
    overviewSubtitle,
    itemSelections, 
    theme, 
    programOverviewShowtimesType,
    showAvailableIn,
    hasGridHoverTrailer,
    hasGridTrailerFeature,
    stripeAppearance,
    highlightAppearance,
    smallSliderAppearance,
    weischerAds,
    itemCollections, 
    sliderAppearance,
    isMobile,
    hasShowtimesFeature,
    mobileOverview,
    translation,
    routesData,
    features,
    customMobilePageElements,
    moviesOrder,
    customMobilePageActive,
    isConnectedFast,
    overview_filter_movies_with_attribute,
    hide_no_performance_movies
}) => {
    const moviesRoutesData = routesData.movies.items
    const {timezone} = translation

    const itemSelectionsDisplayFiltered = _.mapObject(itemSelectionsDisplay, function (val, key) {
        if(key === 'items') {
            return _.omit(itemSelectionsDisplay.items, function (value, key, object) {
                return object[key].type === MAIN;
            })
        } else if(key === 'order') {
            return _.reject(itemSelectionsDisplay.order, pk => {
                return itemSelectionsDisplay.items[pk].type === MAIN;
            })
        }
    })

    let filteredMovies = {
        items: {},
        order: []
    }

    if (overview_filter_movies_with_attribute && overview_filter_movies_with_attribute.length !== 0) {
        moviesOrder.map(moviePk => {
            const movie = movies[moviePk]
            const { technologyAttributes, performances, limitations } = movie
            const { visibleFrom } = limitations
            const technogolyAttributesIds = []
            let hideAllPerformances = false

            if (visibleFrom) {
                const performanceDate = getMomentDateObj(visibleFrom, timezone)
                hideAllPerformances = getMomentNow(timezone).isBefore(performanceDate)
            }

            if (technologyAttributes && technologyAttributes.length !== 0) {
                technologyAttributes.map(attr => {
                    //for when "Vorschau" movies get performances to show and aren't empty anymore
                    if (attr.name.toLowerCase() === 'vorschau' && performances.length > 0 && !hideAllPerformances) {
                        return ''
                    } else {
                        technogolyAttributesIds.push(attr.id)
                    }
                })
            }

            const compareArrays = _.intersection(overview_filter_movies_with_attribute, technogolyAttributesIds)

            if (compareArrays.length === 0) {
                filteredMovies.order.push(moviePk)
                filteredMovies.items[moviePk] = movie
            }
        })
    } else {
        filteredMovies = {
            items: movies,
            order: moviesOrder
        }
    }

    if(hide_no_performance_movies) {
        let moviesWithPerformances = {
            items: {},
            order: []
        }

        filteredMovies.order.map(moviePk => {
            const movie = movies[moviePk]
            const { performances } = movie

            if(performances.length > 0) {
                moviesWithPerformances.order.push(moviePk)
                moviesWithPerformances.items[moviePk] = movie
            }
        })

        filteredMovies = moviesWithPerformances
    }
    
    
    return customMobilePageElements && customMobilePageElements.map((element, index) => {
        const {title, type, name, button_type, jumpingpoint, url, overview_filter_name, overview_filter_type, overview_start_view, overview_filter_ignore_on_performances, frontpage_sandwichelement_pk} = element
        const containerId = type === BUTTON ? type + '-' + button_type : type
        let itemSelectionFrontpageElement 
        let singleItemSelectionsFiltered 

        if(frontpage_sandwichelement_pk) {
            itemSelectionFrontpageElement = _.find(itemSelectionsDisplay.items, selectionDisplay => {
                const {selectionId} = selectionDisplay

                return selectionId === frontpage_sandwichelement_pk
            })
        }

        if(itemSelectionFrontpageElement) {
            const { id } = itemSelectionFrontpageElement
            singleItemSelectionsFiltered = {
                "items": {
                    [id]: itemSelectionFrontpageElement
                },
                "order": [id]
            }
        }

        return <div className={'custom-front-mobile-item-wrapper ' + theme.toLowerCase()} id={containerId} key={index}>
            {title !== '' && <div className='mobile-element-title title-xlarge-black grid-site-wrapper'>{title}</div>}
            {(type === GRID_ELEMENT || type === SHOWTIMES_ELEMENT || type === LIST_ELEMENT) && movies && <Overview
                theme={theme}
                isMobile={isMobile}
                translation={translation}
                overviewSubtitle={overviewSubtitle}
                programOverviewShowtimesType={programOverviewShowtimesType}
                routesData={routesData}
                stripeAppearance={stripeAppearance}
                additionalScrollName={'-' + containerId}
                movies={filteredMovies.items}
                moviesOrder={filteredMovies.order}
                location={location}
                siteHeaderData={siteHeaderData}
                programOverviewStartviewType={programOverviewStartviewType}
                overviewFilterType={overview_filter_type}
                overviewFilterName={overview_filter_name}
                overviewFilterIgnoreOnPerformances={overview_filter_ignore_on_performances}
                overviewStartView={overview_start_view}
                hasShowtimesFeature={hasShowtimesFeature}
                mobileOverview={mobileOverview}
                hasGridHoverTrailer={hasGridHoverTrailer}
                hasGridTrailerFeature={hasGridTrailerFeature}
                weischerAds={weischerAds}
                advertisements={advertisements}
                features={features}
                customMobilePageActive={customMobilePageActive}
                customMobilePageType={type}
                />}
            {type === FRONTPAGE_DESKTOP_ELEMENT && <SelectionsDisplayList
                showAvailableIn={showAvailableIn}
                stripeAppearance={stripeAppearance}
                programOverviewShowtimesType={programOverviewShowtimesType}
                highlightAppearance={highlightAppearance}
                smallSliderAppearance={smallSliderAppearance}
                theme={theme}
                sliderAppearance={sliderAppearance}
                moviesRoutesData={moviesRoutesData}
                translation={translation}
                itemSelectionsDisplay={itemSelectionsDisplayFiltered}
                itemSelections={itemSelections}
                itemCollections={itemCollections}
                movies={movies}
                highlights={highlights}
                additionalScrollName={'-' + containerId}
                ads={ads}
                advertisements={advertisements}
                weischerAds={weischerAds}
                features={features}
                isConnectedFast={isConnectedFast}
                />}    
            {type === OVERVIEW_ELEMENT && movies && <Overview
                theme={theme}
                translation={translation}
                programOverviewShowtimesType={programOverviewShowtimesType}
                routesData={routesData}
                isMobile={isMobile}
                overviewSubtitle={overviewSubtitle}
                additionalScrollName={'-' + containerId}
                stripeAppearance={stripeAppearance}
                overviewFilterType={overview_filter_type}
                overviewFilterName={overview_filter_name}
                overviewStartView={overview_start_view}
                customMobilePageType={type}
                movies={filteredMovies.items}
                moviesOrder={filteredMovies.order}
                location={location}
                overviewFilterIgnoreOnPerformances={overview_filter_ignore_on_performances}
                siteHeaderData={siteHeaderData}
                programOverviewStartviewType={programOverviewStartviewType}
                hasShowtimesFeature={hasShowtimesFeature}
                mobileOverview={mobileOverview}
                hasGridTrailerFeature={hasGridTrailerFeature}
                hasGridHoverTrailer={hasGridHoverTrailer}
                weischerAds={weischerAds}
                advertisements={advertisements}
                features={features}
                isConnectedFast={isConnectedFast}
            />}
            {type === FRONTPAGE_SANDWICH_ELEMENT && frontpage_sandwichelement_pk && itemSelectionFrontpageElement && <SelectionsDisplayList
                showAvailableIn={showAvailableIn}
                stripeAppearance={stripeAppearance}
                programOverviewShowtimesType={programOverviewShowtimesType}
                highlightAppearance={highlightAppearance}
                smallSliderAppearance={smallSliderAppearance}
                theme={theme}
                sliderAppearance={sliderAppearance}
                moviesRoutesData={moviesRoutesData}
                translation={translation}
                itemSelectionsDisplay={singleItemSelectionsFiltered}
                itemSelections={itemSelections}
                itemCollections={itemCollections}
                movies={movies}
                highlights={highlights}
                additionalScrollName={'-' + containerId}
                ads={ads}
                advertisements={advertisements}
                weischerAds={weischerAds}
                features={features}
                isConnectedFast={isConnectedFast}
            />
            }
            {type === BUTTON && button_type === 'link' &&  <div className='button-wrapper'>
                <a className='button text-medium cursor-pointer' href={url}>{name}</a>
            </div>}    
            {type === BUTTON && button_type === 'jump' && <div className='button-wrapper'>
                <ReactScrollLink to={jumpingpoint} smooth={true} offset={-120} className='button text-medium cursor-pointer'>{name}</ReactScrollLink>
            </div>}    
        </div>
    })
}

export default PageFrontCustomMobile